module.exports = __webpack_public_path__ + "media/images/main/bedtime-7ac228cbadb22f7e00ccd10447f7fe03.jpg";